import React from 'react';
import { HashRouter as Router,Route,Link} from 'react-router-dom';
class User extends React.Component{

    constructor(props){

        super(props);
        this.state={

            name:""
        }
    }
 
    render(){

        return(
        <Router>   
        <div className="user">
            <div className="content">
               <div className="left">
          
                  <Link to="/user/">个人中心</Link>
                  <br/>
                  <br/>
                  <Link to="/user/info">用户信息</Link>
               </div> 
               <div className="right">    
                 {/*遍历所有字路由 值取需要的路由*/}
                 {
                    this.props.routes.map((route,key)=>{
                       if(route.exact){
                        return  <Route key ={key} exact  path={route.path} component={route.component}/>  
                       }else{
                       return  <Route key ={key}  path={route.path} component={route.component}/>  
                       }
                    })

                 }   
               </div>  
            </div>
        </div>
        </Router>
        );
    }
}
export default User;


// WEBPACK FOOTER //
// ./src/components/User.js